import { render, staticRenderFns } from "./PdfView.vue?vue&type=template&id=c0ab9ebe&scoped=true"
import script from "./PdfView.vue?vue&type=script&lang=js"
export * from "./PdfView.vue?vue&type=script&lang=js"
import style0 from "./PdfView.vue?vue&type=style&index=0&id=c0ab9ebe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ab9ebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ab9ebe')) {
      api.createRecord('c0ab9ebe', component.options)
    } else {
      api.reload('c0ab9ebe', component.options)
    }
    module.hot.accept("./PdfView.vue?vue&type=template&id=c0ab9ebe&scoped=true", function () {
      api.rerender('c0ab9ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/PdfView.vue"
export default component.exports